interface RelationType {
	module: string;
	label: string;
	uidField: string;
	titleField: string;
	dateField?: string;
	deletedField: string;
	current?: boolean;
}

export function getRelationsTypes(parentModuShort: string) {
	return [
		{
			module: 'marketingactions',
			label: 'DETAILS_FLOW_FIELD_MARKETINGACTION',
			uidField: `${parentModuShort}_maac_uid`,
			titleField: 'maac_title',
			dateField: 'maac_d_from',
			deletedField: 'maac_deleted'
		},
		{
			module: 'commercialcampaigns',
			label: 'DETAILS_FLOW_FIELD_COMMERCIALCAMPAIGN',
			uidField: `${parentModuShort}_cmcp_uid`,
			titleField: 'cmcp_title',
			dateField: 'cmcp_d_from',
			deletedField: 'cmcp_deleted'
		},
		{
			module: 'dems',
			label: 'DETAILS_FLOW_FIELD_DEM',
			uidField: `${parentModuShort}_dems_uid`,
			titleField: 'dems_title',
			dateField: 'dems_date',
			deletedField: 'dems_deleted'
		},
		{
			module: 'opportunities',
			label: 'DETAILS_FLOW_FIELD_OPPORTUNITY',
			uidField: `${parentModuShort}_oppo_uid`,
			titleField: 'oppo_title',
			dateField: 'oppo_d_from',
			deletedField: 'oppo_deleted'
		},
		{
			module: 'contracts',
			label: 'DETAILS_FLOW_FIELD_CONTRACT',
			uidField: `${parentModuShort}_cntr_uid`,
			titleField: 'cntr_title',
			dateField: 'cntr_d_from',
			deletedField: 'cntr_deleted'
		},
		{
			module: 'orders',
			label: 'DETAILS_FLOW_FIELD_ORDER',
			uidField: `${parentModuShort}_ords_uid`,
			titleField: 'ords_title',
			dateField: 'ords_d_from',
			deletedField: 'ords_deleted'
		},
		{
			module: 'projects',
			label: 'DETAILS_FLOW_FIELD_PROJECT',
			uidField: `${parentModuShort}_proj_uid`,
			titleField: 'proj_title',
			dateField: 'proj_d_from',
			deletedField: 'proj_deleted'
		},
		{
			module: 'activities',
			label: 'DETAILS_FLOW_FIELD_ACTIVITY',
			uidField: `${parentModuShort}_acti_uid`,
			titleField: 'acti_title',
			dateField: 'acti_d_from',
			deletedField: 'acti_deleted'
		},
		{
			module: 'tickets',
			label: 'DETAILS_FLOW_FIELD_TICKET',
			uidField: `${parentModuShort}_tick_uid`,
			titleField: 'tick_title',
			dateField: 'tick_d_from',
			deletedField: 'tick_deleted'
		},
		{
			module: 'workreports',
			label: 'DETAILS_FLOW_FIELD_WORKREPORT',
			uidField: `${parentModuShort}_wore_uid`,
			titleField: 'wore_title',
			dateField: 'wore_date',
			deletedField: 'wore_deleted'
		},
		{
			module: 'chronology',
			label: 'DETAILS_FLOW_FIELD_CHRONOLOGY',
			uidField: `${parentModuShort}_chro_uid`,
			titleField: 'chro_title',
			dateField: 'chro_date',
			deletedField: 'chro_deleted'
		}
	] as RelationType[];
}

export default { getRelationsTypes };
